import React from 'react';
import cx from 'classnames';
// widgets
import CloseIcon from '@/widgets/CloseIcon';
// styles
import styles from './WarningNotification.module.scss';
const WarningNotification = ({ children, onClose, className }) => {
    return (React.createElement("div", { className: cx(className, styles.container) },
        children,
        React.createElement(CloseIcon, { onModalClose: onClose })));
};
export default WarningNotification;
